import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import promoReducer from "../features/auth/promo/promoSlice";
import productReducer from "../features/auth/product/productSlice";
import ordersReducer from "../features/orderStatusHistories/ordersStatusHistoriesSlice";  

export const store = configureStore({
  reducer: {
    auth: authReducer,
    promo: promoReducer,
    product: productReducer,
    orders: ordersReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
